import { Actor } from "../actor.js";
import { Layer } from "../tile.js";
import { actorDB } from "../const.js";
import { getTileWirable, WireOverlapMode } from "../wires.js";
export function globalButtonFactory(color) {
    var _a;
    return _a = class extends Actor {
            constructor() {
                super(...arguments);
                this.id = `button${color[0].toUpperCase()}${color.substr(1).toLowerCase()}`;
            }
            getLayer() {
                return Layer.STATIONARY;
            }
            actorCompletelyJoined() {
                var _a, _b;
                (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("button press");
                for (const actor of this.level.actors)
                    if (actor.caresButtonColors.includes(color))
                        (_b = actor.buttonPressed) === null || _b === void 0 ? void 0 : _b.call(actor, color);
            }
            actorLeft() {
                var _a;
                for (const actor of this.level.actors)
                    if (actor.caresButtonColors.includes(color))
                        (_a = actor.buttonUnpressed) === null || _a === void 0 ? void 0 : _a.call(actor, color);
            }
        },
        _a.tags = ["button"],
        _a;
}
export function globalComplexButtonFactory(color) {
    var _a;
    return _a = class extends Actor {
            constructor() {
                super(...arguments);
                this.id = `complexButton${color[0].toUpperCase()}${color
                    .substr(1)
                    .toLowerCase()}`;
            }
            getLayer() {
                return Layer.STATIONARY;
            }
            actorCompletelyJoined(other) {
                var _a, _b;
                (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("button press");
                for (const actor of this.level.actors)
                    if (actor.caresButtonColors.includes(color))
                        (_b = actor.buttonPressed) === null || _b === void 0 ? void 0 : _b.call(actor, color, other.direction.toString());
            }
            actorLeft(other) {
                var _a;
                for (const actor of this.level.actors)
                    if (actor.caresButtonColors.includes(color))
                        (_a = actor.buttonUnpressed) === null || _a === void 0 ? void 0 : _a.call(actor, color, other.direction.toString());
            }
        },
        _a.tags = ["button"],
        _a;
}
class ButtonGreen extends globalButtonFactory("green") {
    actorCompletelyJoined() {
        super.actorCompletelyJoined();
        this.level.greenButtonPressed = !this.level.greenButtonPressed;
    }
}
actorDB["buttonGreen"] = ButtonGreen;
class ButtonBlue extends globalButtonFactory("blue") {
    actorCompletelyJoined() {
        super.actorCompletelyJoined();
        this.level.blueButtonPressed = !this.level.blueButtonPressed;
    }
}
actorDB["buttonBlue"] = ButtonBlue;
class ComplexButtonYellow extends globalComplexButtonFactory("yellow") {
    actorCompletelyJoined(other) {
        super.actorCompletelyJoined(other);
        this.level.currentYellowButtonPress = other.direction + 1;
    }
}
actorDB["complexButtonYellow"] = ComplexButtonYellow;
export function ROConnectedButtonFactory(color, shouldActivateOnLevelStart) {
    var _a;
    return _a = class extends Actor {
            constructor() {
                super(...arguments);
                this.id = `button${color[0].toUpperCase()}${color.substr(1).toLowerCase()}`;
                this.connectedActor = null;
                this.explicitlyConnectedTile = null;
            }
            getLayer() {
                return Layer.STATIONARY;
            }
            levelStarted() {
                var _a, _b, _c, _d, _e;
                // Search for an explicit connection
                for (const connection of this.level.connections)
                    if (connection[0][0] === this.tile.x &&
                        connection[0][1] === this.tile.y)
                        this.explicitlyConnectedTile =
                            (_a = this.level.field[connection[1][0]]) === null || _a === void 0 ? void 0 : _a[connection[1][1]];
                const thisIndex = this.level.actors.indexOf(this);
                const foundActor = [
                    // TODO This relies that actor order is in RRO, maybe this should do it more like teleports?
                    ...this.level.actors.slice(thisIndex),
                    ...this.level.actors.slice(0, thisIndex),
                    ...((_c = (_b = this.explicitlyConnectedTile) === null || _b === void 0 ? void 0 : _b.allActors) !== null && _c !== void 0 ? _c : []), // Try the explicitly connected one first
                ]
                    .reverse()
                    .find(actor => actor.caresButtonColors.includes(color));
                if (foundActor)
                    this.connectedActor = foundActor;
                if (shouldActivateOnLevelStart && this.tile.hasLayer(Layer.MOVABLE))
                    (_e = (_d = this.connectedActor) === null || _d === void 0 ? void 0 : _d.buttonPressed) === null || _e === void 0 ? void 0 : _e.call(_d, color, "init");
            }
            actorCompletelyJoined() {
                var _a, _b, _c, _d;
                (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("button press");
                if (!((_b = this.connectedActor) === null || _b === void 0 ? void 0 : _b.exists))
                    this.connectedActor = null;
                (_d = (_c = this.connectedActor) === null || _c === void 0 ? void 0 : _c.buttonPressed) === null || _d === void 0 ? void 0 : _d.call(_c, color);
            }
            actorLeft() {
                var _a, _b, _c;
                if (!((_a = this.connectedActor) === null || _a === void 0 ? void 0 : _a.exists))
                    this.connectedActor = null;
                (_c = (_b = this.connectedActor) === null || _b === void 0 ? void 0 : _b.buttonUnpressed) === null || _c === void 0 ? void 0 : _c.call(_b, color);
            }
            actorDestroyed() {
                var _a, _b, _c;
                if (!((_a = this.connectedActor) === null || _a === void 0 ? void 0 : _a.exists))
                    this.connectedActor = null;
                (_c = (_b = this.connectedActor) === null || _b === void 0 ? void 0 : _b.buttonUnpressed) === null || _c === void 0 ? void 0 : _c.call(_b, color);
            }
        },
        _a.tags = ["button"],
        _a;
}
actorDB["buttonRed"] = ROConnectedButtonFactory("red");
actorDB["buttonBrown"] = ROConnectedButtonFactory("brown", true);
export function diamondConnectedButtonFactory(color) {
    var _a;
    return _a = class extends Actor {
            constructor() {
                super(...arguments);
                this.id = `button${color[0].toUpperCase()}${color.substr(1).toLowerCase()}`;
                this.connectedActor = null;
                this.explicitlyConnectedTile = null;
            }
            getLayer() {
                return Layer.STATIONARY;
            }
            levelStarted() {
                var _a;
                // Search for an explicit connection
                for (const connection of this.level.connections)
                    if (connection[0][0] === this.tile.x &&
                        connection[0][1] === this.tile.y)
                        this.explicitlyConnectedTile =
                            (_a = this.level.field[connection[1][0]]) === null || _a === void 0 ? void 0 : _a[connection[1][1]];
                if (this.explicitlyConnectedTile) {
                    for (const actor of this.explicitlyConnectedTile.allActors)
                        if (actor.caresButtonColors.includes(color))
                            this.connectedActor = actor;
                }
                else {
                    const maxDimension = Math.max(this.level.width, this.level.height);
                    mainLoop: for (let currentLevel = 1; currentLevel <= maxDimension + 1; currentLevel += 1) {
                        for (const tile of this.tile.getDiamondSearch(currentLevel)) {
                            for (const actor of tile.allActors) {
                                if (actor.caresButtonColors.includes(color)) {
                                    this.connectedActor = actor;
                                    break mainLoop;
                                }
                            }
                        }
                    }
                }
            }
            actorCompletelyJoined() {
                var _a, _b, _c, _d;
                (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("button press");
                if (!((_b = this.connectedActor) === null || _b === void 0 ? void 0 : _b.exists))
                    this.connectedActor = null;
                (_d = (_c = this.connectedActor) === null || _c === void 0 ? void 0 : _c.buttonPressed) === null || _d === void 0 ? void 0 : _d.call(_c, color);
            }
            actorLeft() {
                var _a, _b, _c;
                if (!((_a = this.connectedActor) === null || _a === void 0 ? void 0 : _a.exists))
                    this.connectedActor = null;
                (_c = (_b = this.connectedActor) === null || _b === void 0 ? void 0 : _b.buttonUnpressed) === null || _c === void 0 ? void 0 : _c.call(_b, color);
            }
        },
        _a.tags = ["button"],
        _a;
}
actorDB["buttonOrange"] = diamondConnectedButtonFactory("orange");
export class ButtonPurple extends Actor {
    constructor() {
        super(...arguments);
        this.id = "buttonPurple";
        this.wireOverlapMode = WireOverlapMode.NONE;
        this.providesPower = true;
        this.requiresFullConnect = true;
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorCompletelyJoined() {
        var _a;
        (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("button press");
    }
    actorOnTile(actor) {
        if (actor.layer !== Layer.MOVABLE)
            return;
        this.poweringWires = 0b1111;
    }
    processOutput() {
        this.poweringWires = 0;
    }
}
ButtonPurple.tags = ["button"];
actorDB["buttonPurple"] = ButtonPurple;
export class ButtonBlack extends Actor {
    constructor() {
        super(...arguments);
        this.id = "buttonBlack";
        this.wireOverlapMode = WireOverlapMode.ALWAYS_CROSS;
        this.poweringWires = 0b1111;
        this.providesPower = true;
        this.requiresFullConnect = true;
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorCompletelyJoined() {
        var _a;
        (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("button press");
    }
    processOutput() {
        const movable = this.tile[Layer.MOVABLE];
        if (movable && movable.cooldown <= 0) {
            this.poweringWires = 0;
            return;
        }
        this.poweringWires = 0b1111;
    }
}
ButtonBlack.tags = ["button"];
actorDB["buttonBlack"] = ButtonBlack;
export class ToggleSwitch extends Actor {
    constructor() {
        super(...arguments);
        this.id = "toggleSwitch";
        this.wireOverlapMode = WireOverlapMode.NONE;
        this.poweringWires = this.customData === "on" ? 0b1111 : 0;
        this.providesPower = true;
        this.requiresFullConnect = true;
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorCompletelyJoined() {
        var _a;
        (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("button press");
        this.customData = this.customData === "on" ? "off" : "on";
    }
    // This is no error, this is how CC2 does it, too
    processOutput() {
        this.poweringWires = this.customData === "on" ? 0b1111 : 0;
    }
}
ToggleSwitch.tags = ["button"];
actorDB["toggleSwitch"] = ToggleSwitch;
export class ButtonGray extends Actor {
    constructor() {
        super(...arguments);
        this.id = "buttonGray";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorCompletelyJoined() {
        var _a, _b, _c, _d;
        (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("button press");
        for (let y = -2; y <= 2; y++) {
            for (let x = -2; x <= 2; x++) {
                const tile = (_b = this.level.field[this.tile.x + x]) === null || _b === void 0 ? void 0 : _b[this.tile.y + y];
                if (!tile)
                    continue;
                (_d = (_c = getTileWirable(tile)).pulse) === null || _d === void 0 ? void 0 : _d.call(_c, false);
            }
        }
    }
}
ButtonGray.tags = ["button"];
actorDB["buttonGray"] = ButtonGray;
//# sourceMappingURL=buttons.js.map